import { useState, useCallback, useEffect } from "react";

const useSticky = (margin = 0) => {
  const [sentinel, setSentinel] = useState(null);
  const [sticky, setSticky] = useState(false);

  const elementRef = useCallback((ref) => {
    if (ref == null) {
      return setSentinel(null);
    }
    const sent = document.createElement("div");
    sent.classList.add("sticky_sentinel");
    ref.parentElement.appendChild(sent);
    setSentinel(sent);
    return null;
  }, []);

  useEffect(() => {
    let observer = null;
    if (sentinel) {
      observer = new IntersectionObserver(
        (records) => {
          records.forEach((record) => {
            const targetInfo = record.boundingClientRect;
            const rootBoundsInfo = record.rootBounds;
            setSticky(targetInfo.bottom > rootBoundsInfo.bottom);
          });
        },
        {
          threshold: [1],
          root: null,
          rootMargin: `${margin}px`,
        }
      );

      observer.observe(sentinel);
    }

    return () => observer && observer.unobserve(sentinel);
  }, [sentinel, margin]);

  return [elementRef, sticky];
};

export default useSticky;
